import * as React from "react";
import { useMount } from "../../../../utils/custom-hooks";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import {
  MFAService,
  MFAServiceProps,
} from "../../../../application/service/smart-apply/mfa/mfa-service";
import { InitTOTP } from "./init-totp";
import { InputWithButton } from "../../../molecules/input-with-button";
import { SettingsTemplate } from "../../../template/settings/default-template";
import {
  DangerButton,
  SecondaryButton,
  Spinner,
  WarningBanner,
} from "@graffer-inc/console-design-kit";
import { AuthContext } from "../../../../auth-state";

export const MFAPage: React.FC<MFAServiceProps> = ({
  isMFAEnabled,
  isLoading,
  handleSwitch,
  fetchMFAStatus,
  matchUiState,
  checkPassword,
  initTOTP,
  enableTOTP,
  disableTOTP,
  cancel,
}) => {
  const authCtx = React.useContext(AuthContext);
  useMount(() => fetchMFAStatus());

  const InputPwd = () => (
    <>
      <h2>2段階認証設定を続ける場合、パスワードを入力してください</h2>
      <div className="column is-half">
        <InputWithButton
          onSubmit={checkPassword}
          type="password"
          btnName="次へ"
          placeholder={"パスワード"}
        />
      </div>
    </>
  );

  return (
    <SettingsTemplate breadcrumbs={[{ to: "#", title: "個人設定" }]}>
      <h1 className="title">
        <i className="fa fa-key" /> 2段階認証設定
      </h1>
      <div className="field">
        <div className="columns">
          <div className="column">
            {authCtx.auth.data?.authMethod !== "password" ? (
              <>
                <WarningBanner
                  message="2段階認証を利用できません"
                  description="SAML認証をご利用のため、Grafferが提供している2段階認証を利用できません。SAML認証のIDプロバイダーが提供している2段階認証の機能をご利用ください。"
                />
              </>
            ) : (
              <>
                {matchUiState({
                  INITIAL: (
                    <div className="box" style={{ maxWidth: "800px" }}>
                      {isLoading ? (
                        <div className="has-text-centered">
                          <Spinner loading={isLoading} />
                        </div>
                      ) : (
                        <article className="media">
                          <div className="media-left">
                            {isMFAEnabled
                              ? "2段階認証は有効です"
                              : "2段階認証は有効ではありません"}
                          </div>
                          <div className="media-content" />
                          <div className="media-right">
                            <input
                              id="MFASwitch"
                              type="checkbox"
                              name="MFASwitch"
                              className="switch"
                              checked={isMFAEnabled}
                              onChange={handleSwitch}
                            />
                            <label htmlFor="MFASwitch" />
                          </div>
                        </article>
                      )}
                    </div>
                  ),
                  INPUT_PWD_TO_ENABLE_TOTP: <InputPwd />,
                  INIT_TOTP: <InitTOTP init={initTOTP} enable={enableTOTP} />,
                  INPUT_PWD_TO_DISABLE_TOTP: <InputPwd />,
                  CONFIRM_DISABLE_TOTP: (
                    <>
                      <p>2段階認証を無効にしますか？</p>
                      <div className="buttons" style={{ maxWidth: "800px" }}>
                        <div className="column is-6">
                          <SecondaryButton
                            type="button"
                            onClick={() => cancel()}
                            text={"キャンセルする"}
                          />
                        </div>
                        <div className="column is-6">
                          <DangerButton
                            type="submit"
                            onClick={() => disableTOTP()}
                            text={"無効にする"}
                          />
                        </div>
                      </div>
                    </>
                  ),
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </SettingsTemplate>
  );
};

export const MFAPageContainer = connectPageService(
  MFAPage,
  () => new MFAService(),
);
